/** Splash HTML (index.html) : min ~1,55 s puis fondu 0,42 s, comme Coffre / Agenda. */
const FX_BOOT_MIN_MS = 1900;
const FX_BOOT_FADE_MS = 420;

let bornAt = 0;
let dismissStarted = false;

export function markFacturxBootSplashBorn() {
  if (bornAt < 1) {
    const fromPage = Number(window.__facturxBootBorn);
    bornAt = Number.isFinite(fromPage) && fromPage > 0 ? fromPage : Date.now();
  }
}

export function dismissFacturxBootSplash() {
  if (dismissStarted) return;
  const el = document.getElementById("facturx-boot");
  if (!el) return;
  dismissStarted = true;
  const wait = Math.max(0, FX_BOOT_MIN_MS - (Date.now() - (bornAt || Date.now())));
  window.setTimeout(() => {
    el.classList.add("fx-boot--exiting");
    window.setTimeout(() => {
      el.remove();
    }, FX_BOOT_FADE_MS);
  }, wait);
}
